import { CourseCard } from "../CourseCard";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { DoodleIcon } from "../DoodleIcon";
import { coursePresentation } from "../../data/coursePresentation";
import { courses } from "../../data/mock";
import {
  findPackagesWithCourse,
  calcPackageSaving,
  getRelatedCourses,
} from "../../lib/relatedCourses";

export const RelatedCoursesSection = ({ course }) => {
  if (!course) return null;

  const pack = findPackagesWithCourse(course, courses)[0];
  const saving = pack ? calcPackageSaving(pack, courses) : null;

  // Профильные курсы без пакетов — пакет показываем отдельной карточкой выше
  const related = getRelatedCourses(course, courses, courses.length)
    .filter((c) => c.category !== "Пакеты курсов")
    .slice(0, 3);

  if (!pack && related.length === 0) return null;

  return (
    <section className="py-16 bg-gray-50" data-testid="related-courses-section">
      <div className="max-w-6xl mx-auto px-6">
        {/* Пакет с этим курсом — главный апсейл */}
        {pack && (
          <Link
            to={`/course/${pack.slug}`}
            className="group block bg-white rounded-2xl border border-gray-200 hover:border-teal-300 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden mb-10"
            data-testid="related-package-card"
          >
            <div className="flex flex-col md:flex-row">
              <div className="md:w-64 shrink-0 aspect-video md:aspect-auto overflow-hidden bg-gray-100">
                <img
                  loading="lazy"
                  src={pack.image}
                  alt={coursePresentation[pack.slug]?.displayTitle || pack.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>

              <div className="flex-1 p-6 md:p-8">
                <div className="flex items-center gap-2 mb-3">
                  <DoodleIcon name="box" size={22} />
                  <span className="text-teal-700 text-sm font-semibold">
                    Этот курс входит в пакет
                  </span>
                </div>

                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  {coursePresentation[pack.slug]?.displayTitle || pack.title}
                </h3>
                <p className="text-gray-500 text-sm mb-5 ">
                  {coursePresentation[pack.slug]?.intro || pack.description}
                </p>

                <div className="flex items-center gap-4 flex-wrap">
                  <span className="text-2xl font-bold text-gray-900">
                    {pack.price.toLocaleString("ru-RU")} ₽
                  </span>
                  {saving && (
                    <>
                      <span className="text-gray-400 line-through">
                        {saving.separately.toLocaleString("ru-RU")} ₽
                      </span>
                      <span className="bg-emerald-50 text-emerald-700 text-sm font-semibold px-3 py-1 rounded-full border border-emerald-100">
                        Выгода {saving.saving.toLocaleString("ru-RU")} ₽
                      </span>
                    </>
                  )}
                  <span className="ml-auto hidden sm:inline-flex items-center gap-1 text-teal-600 font-medium group-hover:gap-2 transition-all">
                    Подробнее <ArrowRight size={16} />
                  </span>
                </div>
              </div>
            </div>
          </Link>
        )}

        {/* Профильные курсы */}
        {related.length > 0 && (
          <>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              <span className="ink-underline">Продолжить обучение</span>
            </h2>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {related.map((c, index) => (
                <CourseCard key={c.id} course={{ ...c, title: coursePresentation[c.slug]?.displayTitle || c.title, description: coursePresentation[c.slug]?.intro || c.description }} index={index} testId={`related-course-${c.slug}`} />
              ))}
            </div>
          </>
        )}
        <Link to="/courses" className="course-catalog-link course-more-link"><span className="course-catalog-text">Посмотреть все курсы</span><ArrowRight size={18}/></Link>
      </div>
    </section>
  );
};
